import React from 'react'
import { Switch, Route, withRouter } from 'react-router-dom'
import Body from '../Body'
import CreateUnit from './CreateUnit'
import ManageUnit from './ManageUnit'
import UnitsScreen from './UnitsScreen'

// const Child = injectState(({ state }) => (
//   <div>
//     { `Our counter is at: ${state.counter}` }
//   </div>
// ));

const Units = ({ history }) =>
  <Body>
    <Switch>
      <Route
        strict
        path="/units/create/"
        render={() =>
          <CreateUnit onCreate={unitId => history.push(`/units/${unitId}/`)} />}
      />
      <Route
        strict
        // Match only mongo id
        path="/units/:unitId([a-f0-9]{24})/"
        component={ManageUnit}
      />
      <Route component={UnitsScreen} />
    </Switch>
  </Body>



export default withRouter(Units)



// WEBPACK FOOTER //
// ./src/Units/index.js